import { __rest, __assign } from '../../external/tslib/tslib.es6.mjs.js';
import { jsx } from 'react/jsx-runtime';
import { useEffect } from 'react';
import { useIMask } from 'react-imask';
import { Input } from '../input/Input.js';

var MaskInput = function (_a) {
    var maskOptions = _a.maskOptions, inputProps = _a.inputProps, props = __rest(_a, ["maskOptions", "inputProps"]);
    var _b = useIMask(maskOptions), ref = _b.ref, maskRef = _b.maskRef, setUnmaskedValue = _b.setUnmaskedValue;
    // Update init value if provided
    useEffect(function () {
        var _a;
        if (inputProps.value) {
            setUnmaskedValue(inputProps.value);
            (_a = maskRef.current) === null || _a === void 0 ? void 0 : _a.updateValue();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var onBlur = function (event) {
        var _a, _b;
        (_a = maskRef.current) === null || _a === void 0 ? void 0 : _a.updateValue();
        inputProps.onChange(event);
        (_b = inputProps.onBlur) === null || _b === void 0 ? void 0 : _b.call(inputProps, event);
    };
    return (jsx(Input, __assign({}, props, { inputProps: __assign(__assign({}, inputProps), { value: undefined, onChange: function () { return null; }, onBlur: onBlur }), maxLength: 20, ref: ref })));
};

export { MaskInput };
